(() => {
  angular.module('pims').filter('timestampToISODate', () => {
    'ngInject';

    return function (timestamp, type) {
      if (typeof timestamp === 'string') timestamp = parseInt(timestamp);
      if (type == 'seconds') return new Date(timestamp * 1000).toISOString();
      if (type == 'milliseconds') return new Date(timestamp).toISOString();
      return new Date().toISOString();
    };
  });
})();